import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { FilesManagerService } from "src/app/dashboard/files-manager/files-manager.service";
import { ConversationsService } from "../../conversations/conversations.service";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { InitialsDirective } from "../../../utils/initials.directive";
import { FormsModule } from "@angular/forms";
import { DragDropDirective } from "../../main/common/drag-drop.directive";
import { NgSwitch, NgSwitchCase, NgClass, NgFor, NgIf } from "@angular/common";
import { HotToastService } from "@ngneat/hot-toast";

declare var jQuery: any;

const STEP = {
  SELECT_FILE: "SELECT_FILE",
  SELECT_RECIPIENT: "SELECT_RECIPIENT",
  GET_EMBEDDED_DOCUMENT: "GET_EMBEDDED_DOCUMENT",
  SENT: "SENT",
};

const REQUEST_STEPS = Object.freeze([
  STEP.SELECT_FILE,
  STEP.SELECT_RECIPIENT,
  STEP.GET_EMBEDDED_DOCUMENT,
  STEP.SENT,
]);

@Component({
    selector: "app-modal-sign-request",
    templateUrl: "./sign-request-modal.component.html",
    styleUrls: [
        "../files-manager.component.scss",
        "./sign-request-modal.component.scss",
    ],
    imports: [
        NgSwitch,
        NgSwitchCase,
        DragDropDirective,
        NgClass,
        NgFor,
        FormsModule,
        NgIf,
        InitialsDirective,
    ]
})
export class SignRequestModalComponent implements OnInit {
  public onClose: Subject<boolean>;
  public onComplete: Subject<any>;

  @Input() currentConversationID: number;

  private fileUpload: ElementRef;
  @ViewChild("fileUpload", { static: false }) set content(content: ElementRef) {
    if (content) {
      this.fileUpload = content;
    }
  }

  isLoading = false;
  selectedFiles = [];
  embeddedUrl: string = "";

  currentStepIdx: number = 0;
  currentStep = REQUEST_STEPS[this.currentStepIdx];

  files: any = [];

  has_file: boolean;

  // form
  requestName: string = "";
  additionalRecipients: string = "";

  conversationClients = [];

  requesterName: string = "";

  constructor(
    public bsModalRef: BsModalRef,
    private toastr: HotToastService,
    private filesManagerService: FilesManagerService,
    private conversationsService: ConversationsService,
    private localStorage: LocalStorageService,
  ) {}

  async ngOnInit() {
    this.onClose = new Subject();
    this.onComplete = new Subject();
    this.requesterName = `${this.localStorage.get("user")["first_name"]} ${
      this.localStorage.get("user")["last_name"]
    }`;

    this.conversationClients =
      await this.conversationsService.get_conversation_users(
        this.currentConversationID,
      );
  }

  previous() {
    this.currentStepIdx--;
    this.loadStep(REQUEST_STEPS[this.currentStepIdx]);
  }

  next() {
    this.currentStepIdx++;
    this.loadStep(REQUEST_STEPS[this.currentStepIdx]);
  }

  canGoNext(): boolean {
    switch (this.currentStep) {
      case STEP.SELECT_FILE:
        return this.selectedFiles.length > 0;

      case STEP.SELECT_RECIPIENT:
        return (
          this.requestName &&
          this.conversationClients.filter((c) => c.selected).length > 0
        );

      default:
        false;
    }
  }

  loadStep(step: string) {
    this.currentStep = step;

    switch (this.currentStep) {
      case STEP.SELECT_RECIPIENT:
        if (this.selectedFiles.length == 1) {
          this.requestName = this.selectedFiles[0].filename;
        }
        break;

      case STEP.GET_EMBEDDED_DOCUMENT:
        this.createSignRequestDocument();
        break;
    }
  }

  async createSignRequestDocument() {
    this.isLoading = true;
    let formData = new FormData();

    formData.append("request_name", this.requestName);

    this.files.forEach((f: File) => formData.append("files", f, f.name));

    this.additionalRecipients
      .split(";")
      .forEach((e) => formData.append("recipients", e));

    this.conversationClients
      .filter((c) => c.selected)
      .map((c) => c.id)
      .forEach((c) => formData.append("client_users", c));

    this.isLoading = true;
    try {
      let res = await this.filesManagerService.createSignatureRequest(
        this.currentConversationID,
        formData,
      );
      this.onComplete.next(res);
    } catch (error) {
      console.log(error);
      this.toastr.error("Something went wrong. Please try again later.");
      return;
    } finally {
      this.isLoading = false;
    }
  }

  fileChange(event: FileList) {
    if (event.length > 0) {
      this.has_file = true;

      for (let i = 0; i < event.length; i++) {
        this.files.push(event[i]);

        const file_: File = event[i];
        const currentIdx = this.selectedFiles.length;
        const fileObj = {
          filename: file_.name,
          ext: file_.name.split(".").pop(),
        };

        this.fileUpload.nativeElement.src = URL.createObjectURL(file_);

        console.log(fileObj);

        if (
          fileObj.ext === "jpg" ||
          fileObj.ext === "jpeg" ||
          fileObj.ext === "gif" ||
          fileObj.ext === "png"
        ) {
          const reader = new FileReader();
          reader.readAsDataURL(file_);

          reader.onload = function () {
            jQuery(".item" + currentIdx).css(
              "background",
              "url(" + reader.result + ")",
            );
          };
          reader.onerror = function (error) {
            console.log("Error: ", error);
          };
        } else {
          jQuery(".item" + currentIdx).attr("style", "");
        }

        this.selectedFiles.push(fileObj);
      }
    } else {
      this.has_file = false;
    }
  }
  upload() {}
  close() {
    this.onClose.next(true);
    this.bsModalRef.hide();
  }
}
